export default __webpack_public_path__ + "static/media/Snd11.dcd683d1.mp3";